import { IRubricDTO, IRubricFieldDTO, IRubricSectionDTO } from '@/dtos';
import { get } from './apiWrapper';

export const getRubricAPI = async (RubricId: string): Promise<IRubricDTO> => {
  const ret = await get<IRubricDTO>(`/rubric/${RubricId}`);
  return ret;
};

export const getRubricByYearAPI = async (yearId: string): Promise<IRubricDTO> => {
  const ret = await get<IRubricDTO>(`/rubric/year/${yearId}`);
  return ret;
};

export const getRubricSectionsAPI = async (
  rubricId: string,
): Promise<{ data: IRubricSectionDTO; count: number }> => {
  const ret = await get<{ data: IRubricSectionDTO; count: number }>(`/rubric/${rubricId}/sections`);
  return ret;
};

export const getRubricFieldsAPI = async (
  rubricId: string,
  sectionId: string,
): Promise<{ data: IRubricFieldDTO; count: number }> => {
  const ret = await get<{ data: IRubricFieldDTO; count: number }>(
    `/rubric/${rubricId}/sections/${sectionId}/fields`,
  );
  return ret;
};

export const getRubricOptionsAPI = async (
  rubricId: string,
  sectionId: string,
  fieldId: string,
): Promise<{ data: IRubricFieldDTO; count: number }> => {
  const ret = await get<{ data: IRubricFieldDTO; count: number }>(
    `/rubric/${rubricId}/sections/${sectionId}/fields/${fieldId}/options`,
  );
  return ret;
};
